<template>
    <div class="flex-col">
        <vnavbar title="消息" class="backbar">
        <template #right>
            <vicon name="search" v-if="!showSearch" @click="showSearch=true" size="20" />
            <span style="color:#ffffff" v-if="showSearch" @click="cancelSearch()">取消</span>
        </template>
        </vnavbar>
        <div class="header" v-if="showSearch">
            <vfield class="search" v-model="searchKey" placeholder="请输入" />
        </div>
        <vpullrefresh class="content" :style="{'height':`${this.screenHeight - 98}px`}" v-model="messagerefreshing" @refresh="onMessageRefresh">
            <vlist v-model="messageloading" :finished="messagefinished" finished-text="" @load="onMessageLoad">
                <div class="flex-col">
                <div class="list2">
                    <div class="list2_item flex-col justify-end" v-for="(m,index) in _messages" @click="updateMessage(m.id)" :key="index">
                        <div class="rowone flex-row">
                            <span class="title"  :class="m.is_read ? '' : 'unRead'">{{m.title}}</span>
                            <span class="datetime">{{m.receive_date}}</span>
                        </div>
                        <span class="messagecontent">{{m.content}}</span>
                        <div class="line flex-col"></div>
                    </div>
                </div>
                </div>
            </vlist>
        </vpullrefresh>
    </div>
</template>

<script>
import { NavBar as vnavbar, Empty, Button as vbutton, PullRefresh as vpullrefresh, List as vlist, Dialog, Field as vfield, Icon as vicon, Tag as vtag, Toast } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `TransferMessage`,
    components: { vnavbar, Empty, vbutton, [Dialog.Component.name]: Dialog.Component, vlist, vpullrefresh, vfield, vicon, vtag, Toast },
    props: {
        visible: { type: Boolean }
    },
    data() {
        return {
            messageloading: false,
            messagefinished: false,
            messagerefreshing: false,
            messages: [],
            searchKey: ``,
            showSearch: false
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`, `operation_ward_auth`, `active_hospital_ward`]),
        _messages() {
            let sk = (this.searchKey && this.searchKey.toUpperCase()) || ``
            let r = _.filter(this.messages, d => {
                let result = true
                if (result && sk.length > 0) {
                    result = (d.content && d.content.toUpperCase().indexOf(sk) > -1)
                }
                return result
            })
            return r
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        cancelSearch() {
            this.showSearch = false
            this.searchKey = ``
        },
        onMessageLoad() {
        },
        alertRead() {
            let ids = this.messages.map(i => i.id)
            this.updateMessage(ids)
        },
        readMessage(id) {
            let ids = [id]
            this.updateMessage(ids)
        },
        updateMessage(id) {
            let req = this.myaxios.get(`/api/Operation/MessageReceive/UpdateNotifyReceive?biz_messageheader_id=${id}&result=true&remark=`)
            req.then(data => {
                this.loadMessageList()
            }).catch(e => {
                console.log(e)
            })
        },
        onMessageRefresh() {
            let that = this
            that.messagerefreshing = true
            this.loadMessageList()
                .then(data => {
                    Toast(`刷新成功`)
                    that.messagerefreshing = false
                })
                .catch(() => {
                    that.messagerefreshing = false
                })
        },
        loadMessageList() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(
                    `/api/Operation/MessageReceive/GetTransferMessage?from=${this.$moment()
                        .add(-7, `Day`)
                        .format(`YYYY-MM-DD`)}&to=${this.$moment().format(`YYYY-MM-DD`)}`
                )
                req.then(data => {
                    this.messages = _.take(
                        _.filter(data, d => {
                            return d.biz_message_content.enum_message_status === 1
                        }),
                        10
                    ).map(d => {
                        return {
                            id: d.biz_message_content.id,
                            receive_date: `【${this.$moment(d.receive_date).format(`MM-DD HH:mm`)}】`,
                            content: d.biz_message_content.content,
                            title: d.biz_message_content.title,
                            sender: d.biz_message_content.sender,
                            is_read: d.id == 0 ? d.biz_message_content.result : d.is_read
                        }
                    })
                    resolve()
                    this.messagefinished = true
                }).catch(e => {
                    console.log(e)
                    this.messagefinished = true
                })
            })
        }
    },
    watch: {
        visible: function(newUrl, oldUrl) {
            if (this.visible) {
                this.loadMessageList()
                clearInterval(this.getMessageInterval)
                this.getMessageInterval = setInterval(() => {
                    this.loadMessageList()
                }, 10000)
            } else {
                clearInterval(this.getMessageInterval)
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import '../mobile_common.css';
.backbar{
    background-color: #04A891;
    border:unset !important;
    /deep/ .van-icon{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__text{
        color:#ffffff !important;
    }
    /deep/ .van-nav-bar__title{
        color:#ffffff !important;
    }
}
.van-hairline--bottom::after{
    border-bottom-width:0px !important;
}
.header {
    color:#ffffff !important;
    background: #04A891 !important;
    font-size: 14px;
    text-align: left;
    padding: 6px;
    .search{
        border-radius: 2px;
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding: 0px !important;
    }
    .patient {
        line-height: 23px;
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        height: 46px;
        .name{
            padding:0 20px;
            font-size: 17px;
        }
    }
    .surgery {
        border-top: 1px dashed #ffffff;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        flex-wrap: wrap;
        div {
            width: 50%;
            height:30px;
            line-height:30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            padding: 0 16px;
        }
        .time{
            flex-basis:100% !important;
        }
    }
    .more{
        align-items: center;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        justify-content: space-between;
        margin: 0 16px;
        padding-bottom: 10px;
        .moredevice{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 500;
            font-size: 16px;
            max-width: 80%;
        }
        }
}
.bottom {
    display: flex;
    position: fixed;
    bottom: 0px;
    width:100%;
    .btnTrans {
        flex:1;
        background: var(--primary-color, #009688);
        margin: 5px;
        height: 40px;
        padding: 0px 30px;
        color: #ffffff;
    }
}

.line{
    margin:0px 24px;
    width:1px;
    height:130px;
    background:#EBEBEB;
}
.scrollContent{
    overflow-y: auto;
    overflow-x: hidden;
}
.content{
    display:flex;
    font-size:20px;
    background-color: #F5F5F5;
    .list2{
        width: 100%;
        justify-content: space-between;
        background-color:#FFFFFF;
        .list2_item{
             .rowone{
                  position: relative;
                  margin: 10px 10px 0 10px;
                    height: 36px;
                    line-height: 36px;
                  .title{
                    width: 73%;
                    overflow-wrap: break-word;
                    color: rgba(51, 51, 51, 1);
                    font-size: 16px;
                    font-weight: 500;
                    text-align: left;
                    white-space: nowrap;
                  }
             }
             .datetime{
                overflow-wrap: break-word;
                color: rgba(153, 153, 153, 1);
                font-size: 16px;
                font-weight: normal;
                text-align: right;
                white-space: nowrap;
             }
             .messagecontent{
                width: 100%;
                overflow-wrap: break-word;
                color: rgba(102, 102, 102, 1);
                font-size: 14px;
                font-weight: normal;
                text-align: left;
                white-space: wrap;
                line-height: 24px;
                margin-left: 10px;
                padding-right: 10px;
             }
             .line{
                width: 100%;
                height: 1px;
                background-color: #F5F5F5;
                margin: 0 10px;
                padding-right: 10px;
             }
            .unRead {
                &::before {
                content: '';
                background: red;
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                position: relative;
                margin-right: 2px;
                }
            }
        }
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/TransferMessage.vue